
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CertificateInterface, CertificateLogInterface } from '@/services/SSL/interfaces';

@Component({})
export default class CertificateLogsDialog extends Vue {
  public visible: boolean = true;

  @Prop() public readonly certificate!: CertificateInterface;

  public destroyComponent(): void {
    this.$emit('close');
  }
}
